export default __webpack_public_path__ + "static/media/Linacon-5-ban.2716d5e9.jpg";